import styled from 'styled-components'
import { colors, derivedColors } from '../../../const'
import { withDisabledButtonStyled } from '../../../const/styles'

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1000;
`

export const ModalContainer = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
`

export const ModalContent = styled.div`
  background-color: ${colors.surface};
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 90%;
  max-width: 500px;
  padding: 24px;
  position: relative;
  margin: 20px;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ compact }) => (compact ? '8px' : '16px')};
  padding-top: 8px;
`

export const ModalTitle = styled.h2`
  font-size: ${({ large }) => (large ? '1.5rem' : '1.25rem')};
  font-weight: 800;
  color: ${colors.textPrimary};
  margin: 0;
  font-family: "Inter";
  text-align: center;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Spacer = styled.div`
  width: 20px;
  flex-shrink: 0;
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${colors.textSecondary};
  padding: 4px;
  &:hover {
    color: ${colors.textPrimary};
  }
`

export const ModalDescription = styled.p`
  color: ${colors.textSecondary};
  line-height: 1.5;
  margin-bottom: 16px;
  font-family: "Inter";
`

export const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid ${colors.borderSubtle};
  border-radius: 6px;
  min-height: 120px;
  resize: vertical;
  font-family: "Inter";
  &:focus {
    outline: none;
    border-color: ${colors.primary};
    box-shadow: 0 0 0 2px ${derivedColors.primaryFocusShadow};
  }
`

export const CharacterCount = styled.span`
  color: ${colors.textSecondary};
  font-size: 0.875rem;
  margin-left: auto;
  font-family: "Inter";
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
`

export const ModalButton = styled.button`
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 4px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-weight: 500;
  color: ${({ color }) => color?.text || colors.surface};
  background-color: ${({ color }) => color?.bg || colors.primary};
  transition: background-color 0.3s;
  &:hover {
    background-color: ${({ color }) =>
    color?.hover || colors.primaryHover};
  }

  ${withDisabledButtonStyled}
`

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const DescriptionWrapper = styled.div`
  flex: 1;
  text-align: center;
`

export const InputFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const InputTitle = styled.div`
  margin-bottom: 8px;
  font-weight: 600;
  color: ${colors.textPrimary};
  font-size: 14px;
`

export const DEFAULT_SAVE_BUTTON_COLOR = {
  bg: colors.primary,
  text: colors.surface,
  hover: colors.primaryHover
}

export const DEFAULT_CANCEL_BUTTON_COLOR = {
  bg: derivedColors.transparentSecondary,
  text: colors.primary,
  hover: derivedColors.transparentSecondaryHover
}
